// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.research_downloads__iXmRH:hover{
  color: var(--hsrcOrange) !important; 
}

.research_container__qnJdB{
  background-color: var(--hsrcBackgroundLight);
}`, "",{"version":3,"sources":["webpack://./src/components/ResearchPaper/research.module.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;AACrC;;AAEA;EACE,4CAA4C;AAC9C","sourcesContent":[".downloads:hover{\r\n  color: var(--hsrcOrange) !important; \r\n}\r\n\r\n.container{\r\n  background-color: var(--hsrcBackgroundLight);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"downloads": `research_downloads__iXmRH`,
	"container": `research_container__qnJdB`
};
export default ___CSS_LOADER_EXPORT___;
